(function(){
    angular
        .module('appback')
        .directive('ngMovimientospedido', movimientosPedido);
        movimientosPedido.$inject = ['PedidosService','StockService','$timeout', 'Upload'];
        function movimientosPedido(PedidosService,StockService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/pedidos/template?name=movimientospedido.twig',
		        scope: {
                    pc:'=',
                },
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
                        scope.movimientos = [];
                        scope.loading = true; 
                        scope.getMovimientos = function(){
                            PedidosService.getMovimientosPedido(scope.pc.pedidoActivoID, function(dataMovimientos){
                                scope.movimientos = dataMovimientos.movimientos;
                                console.log("movim",scope.movimientos);
                                scope.loading = false;
                            });
                        }
                        scope.getMovimientos();
			        });
		        }
          }
      }
})();